import { CFG } from '../types';

const initialState = {
  baseUrl: '',
};

const cfgReducer = (state = initialState, action) => {
  switch (action.type) {
    case CFG.BASE_URL:
      let baseUrl = action.baseUrl;
      return {
        ...state,
        baseUrl: baseUrl,
      };

    default:
      return state;
  }
};

export default cfgReducer;
